import { render, staticRenderFns } from "./CTTSpecialReward.vue?vue&type=template&id=210d2b23"
import script from "./CTTSpecialReward.vue?vue&type=script&lang=js"
export * from "./CTTSpecialReward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports